import { LogoImages, Images, QuestionGroup, QuestionType, ScenarioStep, Steps, Translatable } from '../state/interfaces'
import { AnswersProviders } from '../answers/interfaces'
import { emailAddress, providers, provinces } from './common-steps'

export const howMuchData: ScenarioStep = {
  id: Steps.HOW_MUCH_DATA,
  group: QuestionGroup.DEFAULT,
  question: 'how-much-data_question',
  tip: 'how-much-data_tip',
  type: QuestionType.CHOICE_AS_PILLS,
  answerPlaceholder: 'how-much-data_answerPlaceholder',
  next: Steps.BUY_OR_BRING_PHONE,
  answers: [
    { id: '0MB', text: { key: 'common_mb-amount', options: { count: 0 } } },
    { id: '250MB', text: { key: 'common_mb-amount', options: { count: 250 } } },
    { id: '500MB', text: { key: 'common_mb-amount', options: { count: 500 } } },
    { id: '1000MB', text: { key: 'common_gb-amount', options: { count: 1 } } },
    { id: '2000MB', text: { key: 'common_gb-amount', options: { count: 2 } } },
    { id: '3000MB', text: { key: 'common_gb-amount', options: { count: 3 } } },
    { id: '4000MB', text: { key: 'common_gb-amount', options: { count: 4 } } },
    { id: '5000MB', text: { key: 'common_gb-amount', options: { count: 5 } } },
    { id: '8000MB', text: { key: 'common_gb-amount', options: { count: 8 } } },
    { id: '9000MB', text: { key: 'common_gb-amount', options: { count: 9 } } },
    { id: '10000MB', text: { key: 'common_gb-amount', options: { count: 10 } } },
    { id: '15000MB', text: { key: 'common_gb-amount', options: { count: 15 } } },
    { id: '20000MB', text: { key: 'common_gb-amount', options: { count: 20 } } },
    { id: '25000MB', text: { key: 'common_gb-amount', options: { count: 25 } } },
    { id: '50000MB', text: { key: 'common_gb-amount', options: { count: 50 } } },
    { id: '100000MB', text: { key: 'common_gb-amount', options: { count: 100 } } },
  ],
}

export const howMuchDataC: ScenarioStep = {
  ...howMuchData,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.BUY_OR_BRING_PHONE,
  answers: [
    { id: '0MB', text: 'option_none' },
    { id: '5000MB', text: { key: 'common_gb-amount', options: { count: 5 } } },
    { id: '10000MB', text: { key: 'common_gb-amount', options: { count: 10 } } },
    { id: '15000MB', text: { key: 'common_gb-amount', options: { count: 15 } } },
    { id: '20000MB', text: { key: 'common_gb-amount', options: { count: 20 } } },
    { id: 'other', text: 'option_other', next: Steps.SLIDER_DATA },
  ],
}

export const howMuchDataB: ScenarioStep = {
  ...howMuchData,
  next: Steps.BUY_OR_BRING_PHONE,
  answers: [
    { id: '0MB', text: { key: 'common_mb-amount', options: { count: 0 } } },
    { id: '250MB', text: { key: 'common_mb-amount', options: { count: 250 } } },
    { id: '500MB', text: { key: 'common_mb-amount', options: { count: 500 } } },
    { id: '1000MB', text: { key: 'common_gb-amount', options: { count: 1 } } },
    { id: '2000MB', text: { key: 'common_gb-amount', options: { count: 2 } } },
    { id: '3000MB', text: { key: 'common_gb-amount', options: { count: 3 } } },
    { id: '4000MB', text: { key: 'common_gb-amount', options: { count: 4 } } },
    { id: '5000MB', text: { key: 'common_gb-amount', options: { count: 5 } } },
    { id: '8000MB', text: { key: 'common_gb-amount', options: { count: 8 } } },
    { id: '9000MB', text: { key: 'common_gb-amount', options: { count: 9 } } },
    { id: '10000MB', text: { key: 'common_gb-amount', options: { count: 10 } } },
    { id: '15000MB', text: { key: 'common_gb-amount', options: { count: 15 } } },
    { id: '20000MB', text: { key: 'common_gb-amount', options: { count: 20 } } },
    { id: '25000MB', text: { key: 'common_gb-amount', options: { count: 25 } }, next: Steps.BIG_ENTREPRISE },
    { id: '50000MB', text: { key: 'common_gb-amount', options: { count: 50 } }, next: Steps.BIG_ENTREPRISE },
    { id: '100000MB', text: { key: 'common_gb-amount', options: { count: 100 } }, next: Steps.BIG_ENTREPRISE },
  ],
}

export const howManyCallingMinutes: ScenarioStep = {
  id: Steps.HOW_MANY_CALLING_MINUTES,
  group: QuestionGroup.DEFAULT,
  question: 'how-many-calling-minutes_question',
  tip: 'how-many-calling-minutes_tip',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.HOW_MUCH_DATA,
  answerPlaceholder: 'how-many-calling-minutes_answerPlaceholder',
  answers: [
    { id: 'unlimitedcalls', text: 'common_unlimited' },
    { id: '0min', text: { key: 'common_minutes-amount', options: { count: 0 } } },
    { id: '100min', text: { key: 'common_minutes-amount', options: { count: 100 } } },
    { id: '500min', text: { key: 'common_minutes-amount', options: { count: 500 } } },
  ],
}

export const howManyCallingMinutesC: ScenarioStep = {
  ...howManyCallingMinutes,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
}

export const howManyCallingMinutesE: ScenarioStep = {
  ...howManyCallingMinutes,
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.COVERAGE,
  metadata: { grandImage: Images.HOW_MANY_MINUTES },
}

export const howManyCallingMinutesF: ScenarioStep = {
  ...howManyCallingMinutes,
  type: QuestionType.CHOICE_AS_PILLS_LARGE_WITH_OPTIONS,
}

export const coverage: ScenarioStep = {
  id: Steps.COVERAGE,
  group: QuestionGroup.DEFAULT,
  question: 'coverage_question',
  tip: 'coverage_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.HOW_MUCH_DATA,
  answers: [
    { id: 'only-province-coverage', text: 'province-only' },
    { id: 'national', text: 'canada-wide-with-flag' },
    { id: 'canadausa', text: 'canada-us-with-flags' },
    { id: 'i-dont-know-coverage', text: 'common_i-dont-know' },
  ],
}

export const callingOptions: ScenarioStep = {
  id: Steps.CALLING_OPTIONS,
  group: QuestionGroup.DEFAULT,
  question: 'calling-options_question',
  tip: 'calling-options_tip',
  type: QuestionType.CHOICE_AS_MULTISELECT_DEFAULT,
  next: Steps.HOW_MUCH_DATA,
  answers: [
    { id: '3G', text: '3G' as Translatable, metadata: { isChecked: true, group: 'technology' } },
    { id: '4G', text: '4G' as Translatable, metadata: { isChecked: true, group: 'technology' } },
    { id: '5G', text: '5G' as Translatable, metadata: { isChecked: true, group: 'technology' } },
    {
      id: 'unlimitedtext',
      text: 'common_unlimited-text' as Translatable,
      metadata: { isChecked: true, group: 'options' },
    },
    { id: 'calldisplay', text: 'common_call-display', metadata: { isChecked: false, group: 'options' } },
    { id: 'canadausa', text: 'common_us-calling-data', metadata: { isChecked: false, group: 'options' } },
    { id: 'voicemail', text: 'common_voicemail', metadata: { isChecked: true, group: 'options' } },
    { id: 'national', text: 'common_national-calling', metadata: { isChecked: false, group: 'options' } },
  ],
}

export const buyOrBringPhone: ScenarioStep = {
  id: Steps.BUY_OR_BRING_PHONE,
  group: QuestionGroup.DEFAULT,
  question: 'buy-or-bring-phone_question',
  type: QuestionType.CHOICE_AS_IMAGES,
  next: Steps.CHOOSE_PHONE_OS,
  answers: [
    {
      id: 'purchase-phone',
      text: 'buy-or-bring-phone_purchase-phone',
      next: Steps.CHOOSE_PHONE_OS,
      metadata: { image: Images.PURCHASE_PHONE },
    },
    {
      id: 'byod',
      text: 'buy-or-bring-phone_byod',
      next: Steps.DONE,
      metadata: { image: Images.BRING_PHONE },
    },
  ],
}

export const buyOrBringPhoneD: ScenarioStep = {
  ...buyOrBringPhone,
  answers: [
    {
      id: 'purchase-phone',
      text: 'buy-or-bring-phone_purchase-phone',
      next: Steps.CHOOSE_PHONE_OS,
      metadata: { image: Images.PURCHASE_PHONE },
    },
    {
      id: 'byod',
      text: 'buy-or-bring-phone_byod',
      next: Steps.EMAIL_ADDRESS,
      metadata: { image: Images.BRING_PHONE },
    },
  ],
}

export const choosePhoneOs: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_OS,
  group: QuestionGroup.DEFAULT,
  clears: [Steps.CHOOSE_PREFERRED_DEVICES_BRANDS],
  question: 'choose-phone-os_question',
  tip: 'choose-phone-os_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS,
  answers: [
    { id: 'all', text: 'common_all', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS },
    { id: 'ios', text: 'common_ios', next: Steps.CHOOSE_PHONE_SIZE },
    { id: 'android', text: 'common_android', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID },
    { id: 'proprietary', text: 'choose-phone-os_proprietary', next: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY },
  ],
}

export const chooseBrands: ScenarioStep = {
  id: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-preferred-devices-brands_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_SIZE,
  answersProvider: AnswersProviders.PHONES_BRANDS,
  answers: [],
}

export const chooseBrandsAndroid: ScenarioStep = {
  id: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_ANDROID,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-preferred-devices-brands_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_SIZE,
  answersProvider: { provider: AnswersProviders.PHONES_BRANDS, options: { os: 'android' } },
  answers: [],
}

export const chooseBrandsProprietary: ScenarioStep = {
  id: Steps.CHOOSE_PREFERRED_DEVICES_BRANDS_PROPRIETARY,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-preferred-devices-brands_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_SIZE,
  answersProvider: { provider: AnswersProviders.PHONES_BRANDS, options: { os: 'proprietaryos' } },
  answers: [],
}

export const choosePhoneSize: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_SIZE,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-size_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_CAMERA,
  answers: [
    { id: 'small', text: 'choose-phone-size_small' },
    { id: 'medium', text: 'choose-phone-size_medium' },
    { id: 'large', text: 'choose-phone-size_large' },
  ],
}

export const choosePhoneSizeO: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_SIZE,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-size_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_MEMORY,
  answers: [
    { id: 'small', text: 'choose-phone-size_small' },
    { id: 'medium', text: 'choose-phone-size_medium' },
    { id: 'large', text: 'choose-phone-size_large' },
  ],
}

export const choosePhoneCamera: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_CAMERA,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-camera_question',
  type: QuestionType.CHOICE_AS_PILLS,
  metadata: {
    image: 'camera',
  },
  next: Steps.CHOOSE_PHONE_MEMORY,
  answers: [
    { id: 'no-preference', text: 'choose-phone-camera_no-preference', metadata: { image: Images.CAMERA_SMALL } },
    { id: 'important', text: 'choose-phone-camera_important', metadata: { image: Images.CAMERA_MEDIUM } },
    { id: 'crucial', text: 'choose-phone-camera_crucial', metadata: { image: Images.CAMERA_LARGE } },
  ],
}

export const choosePhoneMemory: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_MEMORY,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-memory_question',
  type: QuestionType.CHOICE_AS_PILLS,
  metadata: {
    image: 'sd-card',
  },
  next: Steps.CHOOSE_WIFI_CALLING,
  answers: [
    { id: 'not-much', text: 'choose-phone-memory_not-much', metadata: { image: Images.MEMORY_SMALL } },
    { id: 'average', text: 'choose-phone-memory_average', metadata: { image: Images.MEMORY_MEDIUM } },
    { id: 'a-lot', text: 'choose-phone-memory_a-lot', metadata: { image: Images.MEMORY_LARGE } },
  ],
}

export const chooseWifiCalling: ScenarioStep = {
  id: Steps.CHOOSE_WIFI_CALLING,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-wifi-calling_question',
  type: QuestionType.CHOICE_AS_PILLS,
  next: Steps.CHOOSE_PHONE_FROM_LIST,
  answers: [
    { id: 'yes', text: 'common_yes' },
    { id: 'no', text: 'common_no' },
    { id: 'i-dont-know', text: 'common_i-dont-know' },
  ],
}

export const choosePhoneFromList: ScenarioStep = {
  id: Steps.CHOOSE_PHONE_FROM_LIST,
  group: QuestionGroup.PHONE_SPECS,
  question: 'choose-phone-from-list_question',
  tip: 'choose-phone-from-list_tip',
  type: QuestionType.NONE,
  answers: [],
  next: Steps.EMAIL_ADDRESS,
}

export const provincesStep = {
  ...provinces,
  next: Steps.CURRENT_PROVIDER,
}

export const provincesStepI = {
  ...provinces,
  next: Steps.BIG_ENTREPRISE2,
}

export const currentProviderMobile: ScenarioStep = {
  ...providers,
  question: { key: 'current-provider_question', options: { providerType: 'mobile' } },
  answers: [
    {
      id: 'bell',
      text: '' as Translatable,
      metadata: { image: LogoImages.BELL, blueImage: LogoImages.BELL_BLUE },
    },
    {
      id: 'chatr',
      text: '' as Translatable,
      metadata: { image: LogoImages.CHATR, blueImage: LogoImages.CHATR_BLUE },
    },
    {
      id: 'eastlink',
      text: '' as Translatable,
      metadata: { image: LogoImages.EASTLINK, blueImage: LogoImages.EASTLINK_BLUE },
    },
    {
      id: 'fido',
      text: '' as Translatable,
      metadata: { image: LogoImages.FIDO, blueImage: LogoImages.FIDO_BLUE },
    },
    {
      id: 'fizz',
      text: '' as Translatable,
      metadata: { image: LogoImages.FIZZ, blueImage: LogoImages.FIZZ_BLUE },
    },
    {
      id: 'freedom-mobile',
      text: '' as Translatable,
      metadata: { image: LogoImages.FREEDOM_MOBILE, blueImage: LogoImages.FREEDOM_MOBILE_BLUE },
    },
    {
      id: 'koodo',
      text: '' as Translatable,
      metadata: { image: LogoImages.KOODO, blueImage: LogoImages.KOODO_BLUE },
    },
    {
      id: 'lucky-mobile',
      text: '' as Translatable,
      metadata: { image: LogoImages.LUCKY_MOBILE, blueImage: LogoImages.LUCKY_MOBILE_BLUE },
    },
    {
      id: 'public-mobile',
      text: '' as Translatable,
      metadata: { image: LogoImages.PUBLIC_MOBILE, blueImage: LogoImages.PUBLIC_MOBILE_BLUE },
    },
    {
      id: 'rogers',
      text: '' as Translatable,
      metadata: { image: LogoImages.ROGERS, blueImage: LogoImages.ROGERS_BLUE },
    },
    {
      id: 'sasktel',
      text: '' as Translatable,
      metadata: { image: LogoImages.SASKTEL, blueImage: LogoImages.SASKTEL_BLUE },
    },
    {
      id: 'shaw',
      text: '' as Translatable,
      metadata: { image: LogoImages.SHAW, blueImage: LogoImages.SHAW_BLUE },
    },
    {
      id: 'telus',
      text: '' as Translatable,
      metadata: { image: LogoImages.TELUS, blueImage: LogoImages.TELUS_BLUE },
    },
    {
      id: 'videotron',
      text: '' as Translatable,
      metadata: { image: LogoImages.VIDEOTRON, blueImage: LogoImages.VIDEOTRON_BLUE },
    },
    {
      id: 'virgin',
      text: '' as Translatable,
      metadata: { image: LogoImages.VIRGIN, blueImage: LogoImages.VIRGIN_BLUE },
    },
    { id: 'no-one-provider', text: 'option_none' },
    { id: 'other-provider', text: 'option_other' },
  ],
  next: Steps.HOW_MANY_CALLING_MINUTES,
}

export const bigEnterprise: ScenarioStep = {
  id: Steps.BIG_ENTREPRISE,
  group: QuestionGroup.DEFAULT,
  question: 'big-entreprise_question',
  tip: 'big-entreprise_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.BUY_OR_BRING_PHONE,
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
}

export const bigEnterprise2: ScenarioStep = {
  id: Steps.BIG_ENTREPRISE2,
  group: QuestionGroup.DEFAULT,
  question: 'big-entreprise2_question',
  tip: 'big-entreprise2_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.CURRENT_PROVIDER,
  answers: [
    {
      id: 'yes',
      text: 'common_yes',
    },
    {
      id: 'no',
      text: 'common_no',
    },
  ],
}

export const sliderData: ScenarioStep = {
  id: Steps.SLIDER_DATA,
  group: QuestionGroup.DEFAULT,
  question: 'how-much-data_question',
  type: QuestionType.SLIDER_DATA,
  next: Steps.BIG_ENTREPRISE,
  answers: [],
  metadata: {
    defaultValue: 25,
    min: 0,
    max: 100,
    colorScheme: 'teal',
    sliderMark: [
      {
        value: 25,
        text: '25',
      },
      {
        value: 50,
        text: '50',
      },
      {
        value: 75,
        text: '75',
      },
    ],
    dataUnitType: 'GB',
    step: 1,
  },
}

export const sliderDataG: ScenarioStep = {
  ...sliderData,
  next: Steps.BUY_OR_BRING_PHONE,
}

export const emailAddressMobile: ScenarioStep = {
  ...emailAddress,
  question: 'email-address-optional_question',
  tip: 'email-address-optional-with-alert_tip',
  answerPlaceholder: 'email-address-optional_answerPlaceholder',
  next: Steps.DONE,
}

export const businessOrNotMobile: ScenarioStep = {
  id: Steps.BUSINESS_OR_NOT_MOBILE,
  group: QuestionGroup.DEFAULT,
  question: 'business-or-not-mobile_question',
  tip: 'business-or-not-mobile_tip',
  type: QuestionType.CHOICE_AS_PILLS_LARGE,
  next: Steps.PROVINCE,
  answers: [
    { id: 'for-me', text: 'common_for-myself', next: Steps.PROVINCE },
    { id: 'for-my-company', text: 'common_for-my-company', next: Steps.DONE },
  ],
}
